import { Button, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import '../scss/discover-invozio.style.scss';
import { getItem, getLocalizedPathFromLocalStorage } from "../helper/localstorage.helper";
import { useNavigate } from "react-router-dom";
import { Trophy, Timer, Lock, Easy } from './images/svg/icons';
import { DiscoverImage } from './images/png/icons'
import { GoArrowRight } from "react-icons/go";

export const DiscoverInvozio = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isMobile = window.innerWidth < 576; 
  const isLaptop = window.innerWidth >= 576 && window.innerWidth < 1440; 
  const features = [
    {
      icon: Trophy,
      title: t("COMMITMENT"),
      description: t("COMMITMENT_DESC"),
    },
    {
      icon: Timer,
      title: t("EFFICIENCY"),
      description: t("EFFICIENCY_DESC"),
    },
    {
      icon: Lock,
      title: t("SECURITY"),
      description: t("SECURITY_DESC"),
    },
    {
      icon: Easy,
      title: t("EASY"),
      description: t("EASY_DESC"),
    },
  ];
  return (
    <Container className="discover-bg padding-140 d-flex align-items-center justify-content-center ">
      <Row className="discover-row">
        <Col md={6} className="px-0">
          <div className="discover-content">
            <h2 className="discover-title mb-0  mt-1">{t("DISCOVER_INVOZIO")}</h2>
            <h6 className="discover-description mb-0
            ">
              {t("DISCOVER_INVOZIO_DESC_1")}
              {t("DISCOVER_INVOZIO_DESC_2")}
              {t("DISCOVER_INVOZIO_DESC_3")}
            </h6>
            <Row className="discover-features-row">

              {isMobile ? <img
                src={DiscoverImage}
                alt="Discover Invozio"
                className="discover-image mt-5 mt-sm-0"
              /> : ''}
              {features.map(({ icon, title, description }, idx) => (
                <Col md={6} key={idx} className={`discover-feature mb-0 pb-0 px-0  ${isLaptop ? 'pt-3' : 'padding-top-60 pt-5'}`}>
                  <div className={`d-flex ${isMobile ? 'flex-row' : 'flex-column'}  align-items-start justify-content-start`}>
                    <div className="feature-icon-box">
                      <img src={icon} alt={title} className="feature-icon-discover" />
                    </div>
                    <h3 className="feature-title ml-2 mx-sm-0">{title}</h3>
                  </div>
                  <p className={`feature-description ${description === t('EFFICIENCY_DESC') && !isMobile && getItem('i18nextLng') == 'en-us' ? ' mr-4' : ''} mt-3 mt-sm-0 mb-0`}>{description}</p>

                </Col>
              ))}
            </Row>
            <div className="d-flex justify-content-start w-100 mt-5  pb-5 pb-sm-0">
              <Button
                variant="primary"
                size="sm"
                className="discover-btn "
                onClick={() => navigate(getLocalizedPathFromLocalStorage({ get: (key: string) => getItem(key) ?? null }, { 'sv-se': 'om-invozio', 'en-us': 'about-invozio' }))}
              >
                <span className="fs-16">{t("READ_MORE_ABOUT_INVOZIO")}
                  {isMobile ? <GoArrowRight size={20} className="mx-2" /> : ' '}
                </span>

              </Button>
            </div>
          </div>
        </Col>
        {!isMobile &&
          <Col md={6} className={`d-flex px-0 half-stretch  align-items-start justify-content-end`}>
            <img
              src={DiscoverImage}
              alt="Discover Invozio"
              className="discover-image"
            />
          </Col>
        }
      </Row>
    </Container>
  );
};
